import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      margin: '1rem',
      width: '28rem',
    },

    inputRoot: {
      color: theme.palette.secondary.main,

      '& .MuiOutlinedInput-input': {
        paddingTop: theme.spacing(1.8),
        paddingBottom: theme.spacing(1.8),
      },

      '&:not(.Mui-error), Mui-focused': {
        '&.success .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.primary.light}`,
        },

        '&:hover.MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${theme.palette.secondary.light}`,
          },
      },

      '&.Mui-error.Mui-focused': {
        '&:hover.MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${theme.palette.error.main}`,
          },
      },

      '&.MuiFilledInput-root': {
        background: '#F1F3F4',
      },
    },

    inputLabelRoot: {
      '&.success, &:not(.Mui-error).Mui-focused.success': {
        color: `${theme.palette.primary.main}`,
      },

      '&:not(.Mui-error).Mui-focused': {
        color: `${theme.palette.secondary.main}`,
      },

      '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink):not(.MuiInputLabel-marginDense)':
        {
          transform: 'translate(1.4rem, 1.6rem) scale(1)',
        },
    },
    helpTextSuccess: {
      color: `${theme.palette.primary.dark}`,
    },
  }),
)
